import enums from '../enums.js';
import feedbackExpressions from '../feedback-expressions.js';

const componentNames = ['feedback'];
const expressions = Object.values(feedbackExpressions);
const highContrast = expressions.map((exp) => `HighContrast${exp}`);
const config = {
  expressions: [...expressions, ...highContrast],
  styleProperties: [
    enums.properties.FEEDBACK_COLOR,
    enums.properties.ON_FEEDBACK_COLOR
  ]
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
